import axios from 'axios';
import mapFinderError from '../utils/errorMapper';
import CoreApi from '@/api/CoreApi';
import { MODULES_BASE_URL } from '@/Constants';
import { IRobotFinderResult, ModuleFolderMapping } from '@/models/RobotFinder';

class RobotFinderService {
  static async getModuleFolderMapping(): Promise<ModuleFolderMapping> {
    try {
      const { data } = await axios.get<ModuleFolderMapping>(
        `${MODULES_BASE_URL}/module_folder_mapping.json`,
      );

      return data;
      // eslint-disable-next-line @typescript-eslint/no-explicit-any
    } catch (err: any) {
      throw new Error(mapFinderError(err));
    }
  }

  static async getDisplayPose(
    moduleString: string,
  ): Promise<number[] | undefined> {
    try {
      const { data } = await CoreApi.axiosClient.get(
        `/calculator/display-pose/${moduleString}`,
      );
      return data;
      // eslint-disable-next-line @typescript-eslint/no-explicit-any
    } catch (err: any) {
      console.error(`Failed to fetch display pose for ${moduleString}: ${err}`);
      return undefined;
    }
  }

  static async getRobotFromModuleIds(
    moduleIds: number[],
  ): Promise<IRobotFinderResult> {
    try {
      const { data } = await CoreApi.axiosClient.post(
        '/calculator/calculate/from-module-ids',
        moduleIds,
      );
      return data;
      // eslint-disable-next-line @typescript-eslint/no-explicit-any
    } catch (err: any) {
      console.error('Failed to fetch module folder mapping.');
      throw new Error(mapFinderError(err));
    }
  }

  static async getGeneratedRobotsForConfigurationString(
    configurationString: string,
    payload: number,
    reach: number,
  ): Promise<IRobotFinderResult[]> {
    try {
      const { data } = await CoreApi.axiosClient.post(
        '/calculator/calculate/from-base-configuration',
        {
          configuration_string: configurationString,
          min_payload: payload,
          min_reach: reach,
        },
      );
      return data;
      // eslint-disable-next-line @typescript-eslint/no-explicit-any
    } catch (err: any) {
      throw new Error(mapFinderError(err));
    }
  }
}

export default RobotFinderService;
